<template>
  <myFormVue addTitle="Add New Playlist" updateTitle="Update Playlist" :submitLoading="submitLoading" :isUpdating="dataObj == null" :step="step_no" :step_count="1" @submit="submit" @closeModal="$emit('closeModal')">
    <div class="modal_body_part split_step">
      <div class="split_part_data">
        <h1 class="title">Details</h1>
        <div class="data-form">
          <b-field label="Name (Required)">
            <b-input v-model="form.name" type="text" placeholder="Enter Name"></b-input>
          </b-field>
          <b-field label="Thumbnail Image">
            <p class="b-field-txt">Select or upload cover image that stands as cover image for the serie. A good cover image  stands out and draws viewers’ attention.</p>
          </b-field>

          <!-- DO NOT DELETE THIS -->
          <!-- <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                  location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL" :uploadurl="$store.state.BASE_URL + 'upload'"
                  name="main-image" :value="form.cover" @onFileSelected="(file) => {
                    form.cover = file;
                  }
                    ">
            <div class="image-upload-widget">Choose Image</div>
          </upload-trigger><br> -->
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                  location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL" :uploadurl="$store.state.BASE_URL + 'upload'"
                  name="main-image" :value="form.cover" @onFileSelected="(file) => {
                    form.cover = file;
                  }
                    ">
            <div class="image-upload-widget">Choose Image</div>
          </upload-trigger><br>
        </div>
        <b-field label="Playlist Category (Required)">
          <b-select placeholder="Select a name" v-model="form.category">
            <option
              v-for="(option, index) in playlistCategory"
              :value="option.name"
              :key="index"
            >
              {{ option.displayName }}
            </option>
          </b-select>
        </b-field>
        <h1 class="title">Visibility</h1>
        <div class="data-form">
          <div class="visibility-grp">
            <h1 class="visibility-grp-title">Save or Publish</h1>
            <p class="visibility-grp-sub">Make your music public, unlisted, or private</p>
            <div class="visibility-togglers">
              <div class="visibility-togglers-each">
                <h1>
                  <b-radio v-model="form.visibility"
                    native-value="private"
                    type="is-success"
                    size="is-small">
                  </b-radio>
                  Private
                </h1>
                <p>Only you and people you choose can watch your video</p>
              </div>
              <div class="visibility-togglers-each">
                <h1>
                  <b-radio v-model="form.visibility"
                    native-value="unlisted"
                    type="is-success"
                    size="is-small">
                  </b-radio>
                  Unlisted
                </h1>
                <p>Anyone with the music link can watch your music</p>
              </div>
              <div class="visibility-togglers-each">
                <h1>
                  <b-radio v-model="form.visibility"
                    native-value="public"
                    type="is-success"
                    size="is-small">
                  </b-radio>
                  Public
                </h1>
                <p>Everyone can watch your video</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="split_part_view">
        <div class="data_cover">
          <img v-if="form.cover" :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + form.cover" alt="Cover Image">
          <b-skeleton v-else id="img-skeleton"></b-skeleton>
          <span class="indicator">Published</span>
        </div>
        <h1 class="name" v-if="form.name">{{ form.name }}</h1>
        <h1 class="name" v-else>
          <b-skeleton width="80%"></b-skeleton>
        </h1>
      </div>
    </div>
  </myFormVue>
</template>

<script>
import myFormVue from '../components/myForm.vue';
export default {
  props: {
    dataObj: {
      type: Object,
      default: null
    }
  },
  components: {myFormVue},
  data() {
    return {
      enableUpload: false,
      uploadedSuccessfully: false,
      isPlaying: false,
      filteredTags: null,
      step_no: 1,
      submitLoading: false,
      playlistCategory: [
        {
          name: 'music',
          displayName: 'Music'
        },
        {
          name: 'education',
          displayName: 'Education'
        },
        {
          name: 'others',
          displayName: 'Others'
        },
        {
          name: 'podcast',
          displayName: 'Podcast'
        }
      ],
      form: {
        cover: null,
        name: '',
        category: null,
        visibility: null,
      }
    }
  },
  mounted() {
    let vm = this;
    if(vm.dataObj) {
      vm.step_no = 2
      vm.form = {
        cover: vm.dataObj.cover,
        name: vm.dataObj.name,
        category: vm.dataObj.playlist_category,
        visibility: vm.dataObj.visibility,
      }
    } else {
      vm.form = {
        cover: null,
        name: null,
        category: null,
        visibility: null,
      }
    }
  },
  methods: {
    submit() {
      let vm = this;
      if(vm.form.name && vm.form.category && vm.form.visibility) {
        vm.submitLoading = true;
        if(vm.dataObj) {
          vm.$store.dispatch('UPDATE_PLAYLIST', {id: vm.dataObj.id, data: vm.form}).then(res => {
            vm.submitLoading = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "SUCCESS!!!",
              text: 'Playlist Updated Successfully',
            });
            vm.$emit('closeModal');
            vm.$emit('refresh');
          }).catch(err => {
            vm.submitLoading = false;
            vm.$notify({
              group: "status",
              type: "error",
              title: "OOPS!!!",
              text: err.response.data.message,
            });
          })
        } else {
          vm.$store.dispatch('ADD_PLAYLIST', vm.form).then(res => {
            vm.submitLoading = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "SUCCESS!!!",
              text: 'Playlist Added Successfully',
            });
            vm.$emit('closeModal');
            vm.$emit('refresh');
          }).catch(err => {
            vm.submitLoading = false;
            vm.$notify({
              group: "status",
              type: "error",
              title: "OOPS!!!",
              text: err.response.data.message,
            });
          })
        }

      } else {
        vm.$notify({
          group: "status",
          type: "error",
          title: "OOPS!!!",
          text: 'Please fill all required fields',
        });
        vm.submitLoading = false;
      }
      console.log('Submitted');
    }
  }
}
</script>

<style lang="scss" scoped>
  .main_modal {
    position: fixed;
    width: 100%;
    height: calc(100% - 60px);
    background: rgba(0, 0, 0, 0.268);
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 20px 0;
    align-items: center;
    overflow-y: scroll;
    transition: .8s;
    z-index: 20;
    @media (max-height: 859px) {
      align-items: flex-start;
    }
    @media (max-width: 450px) {
      padding: 0;
    }
    &.activeSide {
      width: calc(100% - 230px);
      @media (max-width: 966px) {
        width: 100%;
      }
      .main_modal_crd {
        .modal_body {
          .modal_body_part {
            &.split_step {
              @media (max-width: 1162px) {
                grid-template-columns: 58% 40%;
              }
              @media (max-width: 768px) {
                grid-template-columns: 100%;
                row-gap: 20px;
              }
            }
          }
        }
      }
    }
    .main_modal_crd {
      width: 90%;
      background: white;
      min-height: 300px;
      height: fit-content;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      @media (max-width: 580px) {
        width: 95%;
      }
      @media (max-width: 450px) {
        width: 100%;
        border-radius: 0;
        height: calc(100vh - 60px);
      }
      .modal_top {
        display: flex;
        padding: 16px 23px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dfdfdf;
        position: sticky;
        top: 0;
        h1{
          font-size: 17px;
          font-weight: 600;
        }
        span {
          cursor: pointer;
        }
      }
      .modal_body {
        height: 550px;
        overflow-y: auto;
        padding: 10px 23px 75px;
        @media (max-width: 580px) {
          padding-bottom: 100px;
        }
        @media (max-width: 450px) {
          padding-bottom: 75px;
          height: 88%;
        }
        .modal_body_part {
          &.upload_step {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .upload_cover {
              display: flex;
              width: 90px;
              height: 90px;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              background: #D9D9D9;
              margin-bottom: 20px;
            }
            h1 {
              font-weight: 600;
              margin-bottom: 5px;
            }
            p{
              opacity: .7;
              text-align: center;
              // margin-bottom: 20px;
            }
            .upload-trigger {
              width: 40%;
              margin-top: 20px;
            }
          }
          &.split_step {
            display: grid;
            grid-template-columns: 68% 30%;
            justify-content: space-between;
            @media (max-width: 1000px) {
              grid-template-columns: 58% 40%;
            }
            @media (max-width: 768px) {
              grid-template-columns: 100%;
              row-gap: 20px;
            }
            .split_part_data {
              h1.title {
                margin-bottom: 15px;
                font-size: 23px;
              }
              .b-field-txt {
                opacity: .6;
                display: flex;
                &.mbottom {
                  margin-bottom: 10px;
                }
              }
              .taginput.control {
                display: flex;
              } 
              .upload-trigger {
                width: 200px;
              }
              .visibility-grp {
                .visibility-grp-title {
                  font-weight: 700;
                }
                .field.has-numberinput {
                  width: 200px;
                }
                .field {
                  .field-body {
                    .field.has-addons{
                      border: 1px solid red;
                    }
                  }
                }
                .visibility-grp-sub {
                  opacity: .7;
                }
                .visibility-togglers {
                  margin-top: 10px;
                  display: flex;
                  flex-direction: column;
                  row-gap: 10px;
                  padding-left: 40px;
                  .visibility-togglers-each {
                    h1 {
                      display: flex;
                    }
                  }
                }
              }
            }
            .split_part_view {
              .data_cover {
                height: 300px;
                border-radius: 10px;
                overflow: hidden;
                position: relative;
                margin-bottom: 13px;
                .b-skeleton {
                  height: 100%;
                  .b-skeleton-item {
                    height: 100%;
                  }
                }
                img {
                  height: 100%;
                  width: 100%;
                  object-fit: cover;
                }
                .media {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 50px;
                  height: 50px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: white;
                  border-radius: 50%;
                  cursor: pointer;
                  box-shadow: 0 0 20px rgba(0, 0, 0, 0.344);
                }
                .indicator {
                  position: absolute;
                  bottom: 20px;
                  right: 20px;
                  background: #6EC492;
                  padding: 6px 13px;
                  font-size: 15px;
                  border-radius: 3px;
                  color: white;
                }
              }
              h1.name {
                font-weight: 600;
                font-size: 20px;
                margin-bottom: 13px;
              }
              p.descr {
                font-size: 16px;
                opacity: .7;
                margin-bottom: 15px;
              }
              .spaced-skeleton {
                margin-bottom: 15px;
              }
              .split_data_pt {
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                .split_data_pt_crd {
                  display: flex;
                  font-size: 15px;
                  .split_data_pt_crd_more {
                    margin-left: 5px;
                    
                    .b-skeleton {
                      height: 100%;
                      .b-skeleton-item {
                        width: 200px;
                      }
                    }
                    span {
                      i {
                        display: inline-flex;
                        margin: 0 2px;
                      }
                      &:last-of-type {
                        i {
                          display: none;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .modal_footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 23px;
        align-items: center;
        background: white;
        z-index: 10;
        border-top: 1px solid #dfdfdf;
        @media (max-width: 580px) {
          flex-direction: column;
          row-gap: 5px;
        }
        span {
          display: flex;
          align-items: center;
        }
        .actions {
          display: flex;
          align-items: center;
          column-gap: 20px;
          @media (max-width: 580px) {
            width: 100%;
            justify-content: space-between;
          }
        }
      }
    }
  }
</style>